import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgBalanceRemainingSelector } from '../../../redux/app/selectors/organization';
import { useNavigationActions } from '../../../lib/navigation/use-navigation-actions.hook';
import { NavigationPaneRouteParamsContext } from '../../../lib/navigation';

export const Balance = () => {
  const { subdomain } = React.useContext(NavigationPaneRouteParamsContext);
  const balanceRemaining = useSelector(orgBalanceRemainingSelector);
  // regex adds commas to long numbers
  const balanceFloat = (balanceRemaining / 10000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const { navigate } = useNavigationActions();

  const handleGoToSupport = () => navigate({
    path: `${window.location.origin}/accounts/${subdomain}/support`,
    params: {},
  });
  return (
    <>
      <p className="orange bold-900 mt-25 mb-10">Balance</p>
      <p className="mb-10">
        Current balance remaining.&nbsp;
        <span
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
          onClick={handleGoToSupport}
          onKeyPress={handleGoToSupport}
          className="link-blue"
        >
          Learn more.
        </span>
      </p>
      <div className="table-container">
        <p className="bold-800">Account Balance</p>
        <div className="flex justify-between">
          <p className="fsz-30 green bold-800">
            $
            {balanceFloat}
          </p>
          {
            // add later
            false && (
              <div className="flex align-center">
                <div className="button sand mr-10">Add More to Balance</div>
                <div className="button sand">Setup Auto Top-up</div>
              </div>
            )
          }
        </div>
      </div>
    </>
  );
};
